var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogoDark(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 423,
    height: 115,
    viewBox: "0 0 423 115",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2634_4030)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M417.9 29.5696H417.85L415.07 25.4196V31.7496H413.54V22.8896H415.2L417.9 27.0796L420.59 22.8896H422.25V31.7496H420.7V25.3996L417.9 29.5696Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M409.01 31.7496H407.44V24.3296H404.63V22.8896H411.82V24.3296H409.01V31.7496Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.73 91.0097V22.8896H400.11V36.2197H363.62V50.0396H395.73V63.3696H363.62V77.6796H400.6V91.0097H348.73Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.62 92.1797C287.41 92.1797 272.81 77.2897 272.81 57.1497V56.9497C272.81 37.5797 287.89 21.7197 308.53 21.7197C320.79 21.7197 328.19 25.0297 335.29 31.0597L325.85 42.4497C320.59 38.0697 315.92 35.5397 308.04 35.5397C297.14 35.5397 288.48 45.1797 288.48 56.7597V56.9497C288.48 69.4097 297.04 78.5497 309.11 78.5497C314.56 78.5497 319.43 77.1897 323.22 74.4597V64.7297H308.14V51.7897H337.72V81.3697C330.71 87.3097 321.08 92.1697 308.62 92.1697",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.16 91.0097H204.59V22.8896H231.16C252.57 22.8896 267.36 37.5796 267.36 56.7596V56.9496C267.36 76.1197 252.57 91.0097 231.16 91.0097ZM251.7 56.9496C251.7 44.8797 243.43 36.4196 231.17 36.4196H219.59V77.4896H231.17C243.43 77.4896 251.7 69.2197 251.7 57.1497V56.9496Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.6 91.9797C160.28 91.9797 149.87 88.3797 141.7 81.0797L150.56 70.4697C156.69 75.5297 163.11 78.7397 170.9 78.7397C177.03 78.7397 180.73 76.3097 180.73 72.3197V72.1297C180.73 68.3297 178.4 66.3897 167.01 63.4697C153.29 59.9697 144.43 56.1697 144.43 42.6397V42.4397C144.43 30.0797 154.36 21.9097 168.27 21.9097C178.2 21.9097 186.66 25.0197 193.57 30.5697L185.78 41.8597C179.75 37.6797 173.81 35.1497 168.07 35.1497C162.33 35.1497 159.31 37.7797 159.31 41.0897V41.2897C159.31 45.7697 162.23 47.2297 174.01 50.2397C187.83 53.8397 195.61 58.7997 195.61 70.6797V70.8697C195.61 84.3997 185.29 91.9897 170.6 91.9897",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.27 31.9397C96.4801 43.1097 52.9901 71.3997 1.32007 69.4297C4.27007 83.2397 11.7901 91.9297 11.7901 91.9297C44.0901 89.7097 95.3301 55.0997 112.28 42.7497C111.33 39.0797 109.9 35.2797 108.27 31.9297",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.28 42.75C112.28 42.75 88.11 81.77 27.75 106.1C33.22 109.36 43.31 114 54.8 114.14C69.45 114.31 79.46 110.77 89.47 104.14C97.77 98.64 105.83 88.72 109.76 78.77C112.51 71.81 114.11 64.39 114.11 56.91C114.11 52.07 113.43 47.24 112.3 42.76",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.16 13.83C84.17 5.22 71.17 0 56.94 0C25.43 0 0 25.5 0 57.02C0 61.22 0.45 65.46 1.31 69.41C1.31 69.41 65.04 60.43 94.16 13.83Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2634_4030"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 422.25,
    height: 114.15,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoDark);
export default __webpack_public_path__ + "static/media/logo_dark.110cca633c88814a19dae0c9a5857e76.svg";
export { ForwardRef as ReactComponent };